import '../assets/NcGuestContent.css';
import { defineComponent, openBlock, createElementBlock, renderSlot } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const _hoisted_1 = { id: "guest-content-vue" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcGuestContent",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});
const NcGuestContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-940ca737"]]);
export {
  NcGuestContent as N
};
//# sourceMappingURL=NcGuestContent.mjs.map
